// extracted by mini-css-extract-plugin
export default {"viewContent":"ViewContent_viewContent__8I8CK"};